import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function AccessControlRule ( props ) {

    return <BasicCrudScreenType id="AccessControlRule" table="AccessControlRule" view="VwAccessControlRule" />

}

export default AccessControlRule;
